<template>
  <footer class="footer">
    <div class="container">
      <div class="footer-nav">
        <NavMenu :data="menu" />
        <Social :data="social" />
      </div>
    </div>
    <div class="footer-rights">
      <div class="container">
        <img :src="logo" />
        <div>
          <div
            class="scroll-top hide-desktop"
            v-scroll-to="{
              el: `.featured`,
              offset: 0,
              force: true,
            }"
          >
            <v-icon name="chevron-up" />
          </div>
          <span v-html="rights.info_1" />
          <span v-html="rights.info_2" />
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  components: {
    NavMenu: () => import("../nav-menu/NavMenu"),
    Social: () => import("../social/Social"),
  },
  props: ["menu", "logo", "social", "rights"],
};
</script>

<style lang="scss" src="./FooterSite.scss" />